import React, { Component } from 'react';

const GridDataTpSearch = ({ data }) => {
    return (
        <><div className='col-md-7 col-xs-12 top-table-info'>
            <div className='row g-0'>
                <div className='col-md-5 col-xs-12'>
                    <label>Transportation Provider Name</label>
                </div>
                <div className='col-md-7 col-xs-12'>
                    <span>{data.carrierName}</span>
                </div>
            </div>
            <div className='row g-0'>
                <div className='col-md-5 col-xs-12'>
                    <label>SCAC Code</label>
                </div>
                <div className='col-md-7 col-xs-12'>
                    <span>{data.carrierSCACCode}</span>
                </div>
            </div>
        </div>
            <div className='col-md-5 col-xs-12 top-table-info'>
                <div className='row g-0'>
                    <div className='col-md-6 col-xs-12'>
                        <label>Total Number of Bills</label>
                    </div>
                    <div className='col-md-6 col-xs-12'>
                        <span>{parseFloat(data.totalCount).toLocaleString('en-US')}</span>
                    </div>
                </div>
                <div className='row g-0'>
                    <div className='col-md-6 col-xs-12'>
                        <label>Total Number of Packages</label>
                    </div>
                    <div className='col-md-6 col-xs-12'>
                        <span>{parseFloat(data.pkgCount).toLocaleString('en-US')}</span>
                    </div>
                </div>
            </div>
        </>

    )
}

export default GridDataTpSearch;
